import { render } from "./form-modal.vue?vue&type=template&id=cb0b3220"
import script from "./form-modal.vue?vue&type=script&lang=ts"
export * from "./form-modal.vue?vue&type=script&lang=ts"

import "./form-modal.vue?vue&type=style&index=0&id=cb0b3220&lang=css"
script.render = render

export default script